/**
 * Class for Planner mobile links
 */ export class PlannerMobileLinks {
}
/** The external link for planner for iOS */ PlannerMobileLinks.plannerForIos = "https://go.microsoft.com/fwlink/?linkid=866042";
/** The external link for planner for Android */ PlannerMobileLinks.plannerForAndroid = "https://go.microsoft.com/fwlink/?linkid=866041";
